<template id="cmsForm">    
    <div>
        
        <div class="row">
            <div class="col-md-11">
                <ul class="nav nav-tabs">
                    <li class="nav-item" @click="toggleTab('first')">
                        <a href="#" class="nav-link" v-bind:class="{'active':!tabHide.first}">
                            <h3>วันเวลาทำการ</h3>
                        </a>
                    </li>
                    <li class="nav-item" @click="toggleTab('second')">
                        <a href="#" class="nav-link" v-bind:class="{'active':!tabHide.second}">
                            <h3>เงื่อนไขการจัดส่ง</h3>
                        </a>
                    </li>                    
                    <li class="nav-item" @click="toggleTab('third')">
                        <a href="#" class="nav-link" v-bind:class="{'active':!tabHide.third}">
                            <h3>ทดสอบเงื่อนไข</h3>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-md-1">
                <a href="/" class="btn btn-secondary ">กลับ</a>
            </div>
        </div>

        <div class="nav-tab" v-bind:class="{'d-none':tabHide.first}">
            <div class="row">
                <div class="col-md-10">
                    <h4 class="m-3 text text-secondary">วันเวลาทำการ จ.=1, อ.=2,... ส.=6, อา.=7</h4>
                </div>
                <div class="col-md-2 mt-2">
                        <button class="btn btn-primary" @click="addNewOpenHour">เพิ่มวันทำการ</button>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-11">
                            <div class="input-group">
                                <input type="text" class="form-control" value="enabled" readonly style="flex: 0 0 9%;">
                                <input type="text" class="form-control" value="day of week" readonly style="flex: 0 0 12%;">
                                <input type="text" class="form-control" value="priority" readonly style="flex: 0 0 8%;">
                                <input type="text" class="form-control" value="start time" readonly style="flex: 0 0 10%; ">
                                <input type="text" class="form-control" value="next to (seconds)" readonly>
                                <input type="text" class="form-control" value="start active" readonly>
                                <input type="text" class="form-control" value="end active" readonly>                                
                            </div>
                        </div>
                        <div class="col-md-1">
                            <input type="text" class="form-control" value="ลบ" readonly>                                
                        </div>
                    </div>
                    <div class="row mt-1" v-for="open_hour in open_hours" v-bind:key="'open_hour_'+open_hour.id">
                        <div class="col-md-11">
                            <div class="input-group">
                                <div class="input-group-text" style="flex: 0 0 9%; flex-direction: column; justify-content: center;">
                                    <input class="form-check-input pl-10" 
                                        type="checkbox"
                                        :checked="open_hour.enabled"
                                        v-model="open_hour.enabled" 
                                        style="margin-left:unset"
                                    >
                                </div>
                                <input type="text" class="form-control" v-model="open_hour.day_of_week" style="flex: 0 0 12%;">
                                <input type="text" class="form-control" v-model="open_hour.priority" style="flex: 0 0 8%; ">
                                <input type="text" class="form-control" v-model="open_hour.start" style="flex: 0 0 10%; ">
                                <input type="text" class="form-control" v-model="open_hour.end">
                                <input type="text" class="form-control" v-model="open_hour.start_active">
                                <input type="text" class="form-control" v-model="open_hour.end_active">
                            </div>
                        </div>
                        <div class="col-md-1">
                            <button class="btn btn-secondary form-control" @click="deleteOpenHour(open_hour)">ลบ</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-11">            
                    <span class="text text-danger" v-bind:class="{'d-block':open_hour_data_entry_error,'d-none':!open_hour_data_entry_error}">
                        ไม่สามารถบันทึกได้ มีปัญหาการกรอกข้อมูลในรายการย่อย กรุณาตรวจสอบ {{open_hour_data_entry_error_message}}
                    </span>

                    <span class="text text-success float-right" v-bind:class="{'d-block':open_hour_data_saved_show,'d-none':!open_hour_data_saved_show}">
                        บันทึกแล้ว!!!!!!
                    </span>
                    
                    <general-loading v-if="showLoading"></general-loading>
                    
                </div>
                <div class="col-md-1">
                    <div class="form-group float-right">                        
                        <button type="button" class="btn btn-primary ml-5" @click="saveOpenHour()">บันทึก</button>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="nav-tab" v-bind:class="{'d-none':tabHide.second}">
            <div class="row">
                <div class="col-md-12">
                    <h4 class="m-3 text text-secondary">เงื่อนไขการจัดส่ง</h4>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-md-11">
                    <div class="input-group">        
                        <span class="input-group-text handle">เงื่อนไขใหม่</span>    
                        <select id="" class="form-control" v-model="new_item_key_string">
                            <option value="-1">key</option>
                            <option 
                                v-for="delivery_time_criteria_key in delivery_time_criteria_keys" 
                                v-bind:key="delivery_time_criteria_key.id" 
                                :value="delivery_time_criteria_key.key+'##'+delivery_time_criteria_key.message+'##'+delivery_time_criteria_key.description"                            
                                >
                                    {{delivery_time_criteria_key.description}}
                                </option>
                        </select>
                        <input type="hidden" class="form-control" placeholder="key" v-model="new_item.key">
                        <input type="hidden" class="form-control" placeholder="value" v-model="new_item.value">
                        <input type="hidden" class="form-control" placeholder="start_active" v-model="new_item.start_active">
                        <input type="hidden" class="form-control" placeholder="end_active" v-model="new_item.end_active">
                        <input type="hidden" class="form-control" placeholder="description" v-model="new_item.description">
                        <select class="form-control" v-model="new_item.enabled">
                            <option value="-1">สถานะ</option>
                            <option value="1">เปิดการใช้งาน</option>
                            <option value="0">ปิดการใช้งาน</option>
                        </select>    
                    </div>    
                </div>
                <div class="col-md-1">
                    <button class="btn btn-primary form-control" @click="addNewItemToMenuItems">เพิ่ม</button>
                </div>
            </div>

            <div class="row mt-10">
                <div class="col-md-12">
                    <nested-dragable :list="delivery_time_criterias" :delivery_time_criteria_keys="delivery_time_criteria_keys" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-11">            
                    <span class="text text-danger" v-bind:class="{'d-block':delivery_time_criteria_item_data_entry_error,'d-none':!delivery_time_criteria_item_data_entry_error}">ไม่สามารถบันทึกได้ มีปัญหาการกรอกข้อมูลในรายการย่อย กรุณาตรวจสอบ </span>            
                    <span class="text text-success float-right" v-bind:class="{'d-block':delivery_time_criteria_saved_show,'d-none':!delivery_time_criteria_saved_show}">
                        บันทึกแล้ว!!!
                    </span>
                    <general-loading v-if="showLoading"></general-loading>
                </div>
                <div class="col-md-1">
                    <div class="form-group float-right">                        
                        <button type="button" class="btn btn-primary ml-5" @click="saveCriterias()">บันทึก</button>
                    </div>
                </div>
            </div>
        </div>        

        <div class="nav-tab" v-bind:class="{'d-none':tabHide.third}">
            <div class="row">
                <div class="col-md-12">
                    <h4 class="m-3 text text-secondary">ทดสอบเงื่อนไขการจัดส่ง</h4>
                </div>                
            </div>
            <div class="row mb-2 text text-secondary">
                <div class="col-md-6">
                    <h5>กรอกเงื่อนไข</h5>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend" style="width:25%">
                                    <span class="input-group-text" style="width:100%">วันที่จัดส่ง</span>
                                </div>
                                <!-- <input type="text" class="form-control" placeholder="yyyy-mm-dd (คศ.)" v-model="testCriteria.date"> -->
                                <datepicker v-model="testCriteria.date" :style="'height:unset;'" :bootstrap-styling="true" :input-class="'form-control'" :placeholder="'yyyy-mm-dd (คศ.)'" :format="'yyyy-MM-dd'" name="test-date"></datepicker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend" style="width:25%">
                                    <span class="input-group-text" style="width:100%">เวลาจัดส่ง</span>
                                </div>
                                <!-- <input type="text" class="form-control" placeholder="hh:mm:ss" v-model="testCriteria.time"> -->
                                <!-- <datepicker v-model="testCriteria.time" :bootstrap-styling="true" :input-class="'form-control'" :placeholder="'H:mm:ss'" :format="'H:mm'" name="test-time"></datepicker> -->
                                <vue-timepicker 
                                    v-model="testCriteria.time" 
                                    :hide-disabled-seconds="false" 
                                    :minute-interval="10" 
                                    :format="'HH:mm:ss'" 
                                    :bootstrap-styling="true" 
                                    :input-class="'form-control'"
                                    :style="'height:unset;background:unset'"
                                    >
                                    </vue-timepicker>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-10">
                            <general-loading v-if="showLoading"></general-loading>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group float-right">                        
                                <button type="button" class="btn btn-primary ml-5" @click="testCriterias()">ทดสอบ</button>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-12">
                            <h5>ผลการทดสอบ</h5>
                        </div>
                    </div>
                    <div class="row" v-if="criteriaTestResult.show">
                        <div class="col-md-12">
                            <div class="row text" 
                                v-bind:class="{'text-success':criteriaTestResult.valid,'text-danger':!criteriaTestResult.valid}"
                                >
                                <div class="col-md-12">
                                    <h5>{{(criteriaTestResult.valid ? 'ผ่าน' : 'ไม่ผ่าน!!')+''}}</h5>
                                </div>
                            </div>
                            <div class="row" 
                                v-for="(valid_error_message,idx) in criteriaTestResult.error_message" 
                                v-bind:key="'validate_error_msg_'+idx"
                            >
                                <div class="col-md-12">
                                    {{valid_error_message.message}}
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>            
        </div>

        
    </div>
</template>

<script>
    import nestedDragable from "./nestedWithUL.vue";
    import Datepicker from 'vuejs-datepicker';
    
    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'

    export default {        
        components: {
            nestedDragable,
            Datepicker,
            VueTimepicker,
        },        
        props:{},
        data() {                        
            let item_validateError = {                
                key:{error:false,message:''},
                description:{error:false,message:''},
                message:{error:false,message:''},
                value:{error:false,message:''},
                start_active:{error:false,message:''},
                end_active:{error:false,message:''},
                priority:{error:false,message:''},
                enabled:{error:false,message:''}, 
            }
            return {          
                item_validateError:item_validateError,
                delivery_time_criteria_item_data_entry_error:false,
                new_item:{
                    key:'new-key',
                    description:'',
                    message:'',
                    value:"",
                    start_active:'2010-01-01 00:00:00',
                    end_active:'2030-01-01 00:00:00',
                    priority:1,
                    enabled:1,
                    children:[],
                },
                initial_delivery_time_criterias:[
                    {
                        "id": 67,
                        "key": "parent",
                        "description": "parent เป็นจริงเสมอ level1",
                        "message": "parent",
                        "parent_id": null,
                        "value": "1",
                        "start_active": "2000-01-01 00:00:00",
                        "end_active": "3000-01-01 00:00:00",
                        "priority": 0,
                        "enabled": 1,
                        "created_at": "2021-11-30T05:08:30.000000Z",
                        "updated_at": "2021-11-30T05:08:30.000000Z",
                        "children": [
                            {
                                "id": 68,
                                "key": "at_least_time_diff",
                                "parent_id": 67,
                                "value": "14400",
                                "start_active": "2000-01-01 00:00:00",
                                "end_active": "3000-01-01 00:00:00",
                                "priority": 1,
                                "enabled": 1,
                                "description": "ไม่ส่งถ้าระยะห่างระหว่างเวลาสั่งถึงเวลาส่งไม่ถึง(วินาที) ไม่นับเวลาเริ่มเปิดร้าน level 2",
                                "message": "ไม่สามารถส่งของได้ภายในเวลา %sน. ของวันที่ %s  ต้องสั่งล่วงหน้าอย่างน้อย %s",
                                "created_at": "2021-11-30T05:08:30.000000Z",
                                "updated_at": "2021-11-30T05:08:30.000000Z",
                                "children": [
                                    {
                                        "id": 69,
                                        "key": "at_least_time_diff",
                                        "parent_id": 68,
                                        "value": "14400",
                                        "start_active": "2000-01-01 00:00:00",
                                        "end_active": "3000-01-01 00:00:00",
                                        "priority": 1,
                                        "enabled": 2,
                                        "description": "ไม่ส่งถ้าระยะห่างระหว่างเวลาสั่งถึงเวลาส่งไม่ถึง(วินาที) ไม่นับเวลาเริ่มเปิดร้าน level3",
                                        "message": "ไม่สามารถส่งของได้ภายในเวลา %sน. ของวันที่ %s  ต้องสั่งล่วงหน้าอย่างน้อย %s",
                                        "created_at": "2021-11-30T05:08:30.000000Z",
                                        "updated_at": "2021-11-30T05:08:30.000000Z",
                                        "children": [
                                            {
                                                "id": 70,
                                                "key": "at_least_time_diff",
                                                "parent_id": 69,
                                                "value": "14400",
                                                "start_active": "2000-01-01 00:00:00",
                                                "end_active": "3000-01-01 00:00:00",
                                                "priority": 1,
                                                "enabled": 1,
                                                "description": "ไม่ส่งถ้าระยะห่างระหว่างเวลาสั่งถึงเวลาส่งไม่ถึง(วินาที) ไม่นับเวลาเริ่มเปิดร้าน level 4",
                                                "message": "ไม่สามารถส่งของได้ภายในเวลา %sน. ของวันที่ %s  ต้องสั่งล่วงหน้าอย่างน้อย %s",
                                                "created_at": "2021-11-30T05:08:30.000000Z",
                                                "updated_at": "2021-11-30T05:08:30.000000Z",
                                                "children": []
                                            },
                                            {
                                                "id": 71,
                                                "key": "at_least_time_diff",
                                                "parent_id": 69,
                                                "value": "14400",
                                                "start_active": "2000-01-01 00:00:00",
                                                "end_active": "3000-01-01 00:00:00",
                                                "priority": 2,
                                                "enabled": 1,
                                                "description": "ไม่ส่งถ้าระยะห่างระหว่างเวลาสั่งถึงเวลาส่งไม่ถึง(วินาที) ไม่นับเวลาเริ่มเปิดร้าน",
                                                "message": "ไม่สามารถส่งของได้ภายในเวลา %sน. ของวันที่ %s  ต้องสั่งล่วงหน้าอย่างน้อย %s",
                                                "created_at": "2021-11-30T05:08:30.000000Z",
                                                "updated_at": "2021-11-30T05:08:30.000000Z",
                                                "children": []
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "id": 72,
                                "key": "at_least_time_diff_plus_office_hour",
                                "parent_id": 67,
                                "value": "14400",
                                "start_active": "2000-01-01 00:00:00",
                                "end_active": "3000-01-01 00:00:00",
                                "priority": 2,
                                "enabled": 1,
                                "description": "ไม่ส่งถ้าเวลาส่งของอยู่ห่างจากเวลาเปิดทำการในวันที่ให้ส่งของน้อยกว่า (วินาที)",
                                "message": "ไม่สามารถส่งของได้ภายในเวลา %sน. เนื่องจากในวันที่ %s บริษัทเปิดทำการในเวลา %sน. สามารถให้ส่งของได้ตั้งแต่เวลา %sน. เป็นต้นไป",
                                "created_at": "2021-11-30T05:08:30.000000Z",
                                "updated_at": "2021-11-30T05:08:30.000000Z",
                                "children": []
                            },
                            {
                                "id": 73,
                                "key": "at_most_time_diff",
                                "parent_id": 67,
                                "value": "864000",
                                "start_active": "2000-01-01 00:00:00",
                                "end_active": "3000-01-01 00:00:00",
                                "priority": 3,
                                "enabled": 1,
                                "description": "ระยะเวลามากสุดที่ห่างได้ระหว่างเวลาสั่งกับเวลาส่ง(วินาที)",
                                "message": "สั่งล่วงหน้าได้ไม่เกิน % วัน",
                                "created_at": "2021-11-30T05:08:30.000000Z",
                                "updated_at": "2021-11-30T05:08:30.000000Z",
                                "children": [
                                    {
                                        "id": 74,
                                        "key": "at_least_time_diff_plus_office_hour",
                                        "parent_id": 73,
                                        "value": "14400",
                                        "start_active": "2000-01-01 00:00:00",
                                        "end_active": "3000-01-01 00:00:00",
                                        "priority": 2,
                                        "enabled": 1,
                                        "description": "ไม่ส่งถ้าเวลาส่งของอยู่ห่างจากเวลาเปิดทำการในวันที่ให้ส่งของน้อยกว่า (วินาที)",
                                        "message": "ไม่สามารถส่งของได้ภายในเวลา %sน. เนื่องจากในวันที่ %s บริษัทเปิดทำการในเวลา %sน. สามารถให้ส่งของได้ตั้งแต่เวลา %sน. เป็นต้นไป",
                                        "created_at": "2021-11-30T05:08:30.000000Z",
                                        "updated_at": "2021-11-30T05:08:30.000000Z",
                                        "children": []
                                    }
                                ]
                            },
                            {
                                "id": 75,
                                "key": "not_delivery_between_time",
                                "parent_id": 67,
                                "value": "01:00+21600",
                                "start_active": "2000-01-01 00:00:00",
                                "end_active": "3000-01-01 00:00:00",
                                "priority": 0,
                                "enabled": 1,
                                "description": "ไมส่งระหว่างเวลาใดของแต่ละวัน, ระบุเวลาเริ่ม + นับไปอีกกี่วินาที",
                                "message": "ไม่ส่งของในช่วงเวลา %sน. ถึงเวลา %sน.",
                                "created_at": "2021-11-30T05:08:30.000000Z",
                                "updated_at": "2021-11-30T05:08:30.000000Z",
                                "children": []
                            },
                            {
                                "id": 76,
                                "key": "not_delivery_between_datetime",
                                "parent_id": 67,
                                "value": "2021-10-10T08,00-2021-10-11T22:00",
                                "start_active": "2021-10-02 00:00:00",
                                "end_active": "2021-10-04 00:00:00",
                                "priority": 5,
                                "enabled": 1,
                                "description": "ไมส่งระหว่าง yyyy-mm-dd hh:mm:ss ถึง yyyy-mm-dd hh:mm:ss",
                                "message": "บริษัทหยุดส่งของระหว่างวันที่ %s เวลา %sน. ถึงวันที่ %s เวลา %sน.",
                                "created_at": "2021-11-30T05:08:30.000000Z",
                                "updated_at": "2021-11-30T05:08:30.000000Z",
                                "children": []
                            }
                        ]
                    }
                    ],
                delivery_time_criterias: [],
                delivery_time_criteria_saved_show:false,
                form:{ 
                    //ชื่อฟิลด์ต่างๆในฟอร์มที่จะ add หรือ edit ชื่อฟิลด์จะเหมือนกับใน postman
                    criterias:this.delivery_time_criterias,
                },                
                validateError:{ 
                    // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ                    
                    delivery_time_criterias:[],
                },
                languages:{ 
                    // เอาไว้เก็บตัวเลือกภาษาใน form select language โดย method fetchLanguages จะไปดึงมาให้จาก laravel                                    
                },
                delivery_time_criteria_keys:{
                    //category ของ delivery_time_key
                },
                base_url:'/delivery-criteria', // base url (เปลี่ยน)    

                new_item_key_string:'',
                tabHide:{
                    first:false,
                    second:true,
                    third:true,
                },
                open_hours:{},
                open_hour_data_entry_error:false,
                open_hour_data_entry_error_message:'',

                open_hour_data_saved_show:false,

                testCriteria:{
                    date:'2022-01-20',
                    time:'08:00:00',
                },

                criteriaTestResult:{
                    show:false,
                    valid:false,
                    error_message:[],
                },

                showLoading:false,
            }
        },    
            
        mounted() {},
        beforeMount(){},
        created(){                        
            this.fetchdelivery_time_criteria_keys();
            this.fetchOpenHour();
        },
        methods:{
            toggleTab(tab){
                this.tabHide.first=true;
                this.tabHide.second=true;
                this.tabHide.third=true;
                this.tabHide[tab] = false;
                // console.log(tab);
                // console.table(this.tabHide);
            },
            vl_props(){
                return {                
                    key:{error:false,message:''},
                    description:{error:false,message:''},
                    message:{error:false,message:''},
                    value:{error:false,message:''},
                    start_active:{error:false,message:''},
                    end_active:{error:false,message:''},
                    priority:{error:false,message:''},
                    enabled:{error:false,message:''},                
                }
            },
            create_new_items(){
                return {
                    key:this.new_item.key,
                    description:this.new_item.description,
                    message:this.new_item.message,
                    value:this.new_item.value,
                    start_active:this.new_item.start_active,
                    end_active:this.new_item.end_active,
                    priority:this.new_item.priority,
                    enabled:this.new_item.enabled,
                    children:[],
                    validateError:this.vl_props(),
                }
            },
            fetch(){
                axios.get(this.base_url+'/fetch').then(response => {
                    // console.log(response.data);
                    //เอาข้อมูลแต่ละฟิลด์ใส่ฟอร์มหลังจากโหลดมาแล้ว
                    this.delivery_time_criterias = response.data.delivery_time_criteria;
                })
                .catch(errors => {
                    // console.log(errors);
                    // alert('ไม่สามารถดึง record id='+id+' ได้');
                })
                ;
            },
            addNewItemToMenuItems(){                
                let ontherock = this.new_item_key_string.split('##');
                console.log(this.new_item_key_string);
                console.log(ontherock);
                let new_item = this.create_new_items();
                new_item.key = ontherock[0];
                new_item.message = ontherock[1];
                new_item.description = ontherock[2];
                this.delivery_time_criterias.push(new_item);
            },
            saveCriterias(){    
                this.showLoading=true;            
                this.delivery_time_criteria_item_data_entry_error = false;
                let me = this; 
                this.form.criterias = this.delivery_time_criterias;
                this.delivery_time_criteria_saved_show = false;
                axios
                .post(this.base_url,this.form)
                .then(response => {
                    this.showLoading=false;
                    console.log(response);
                    // this.languages = response.data.items;        
                    // location.reload();
                    this.delivery_time_criteria_saved_show = true;
                }).catch(errors => {
                    this.showLoading=false;
                    if(errors.response.data.message){
                        let errorMessage = errors.response.data.message;   
                        // console.log(errorMessage);            
                        // console.log(typeof errorMessage);
                        let fields = Object.keys(this.form);
                        fields.forEach(function(item,key){                            
                            if(typeof errorMessage[item] !='undefined'){
                                me.validateError[item].error = true;
                                me.validateError[item].message = errorMessage[item][0];
                            }
                        });

                        Object.keys(errorMessage).forEach(function(key){
                            // console.log(key);
                            let splited_key = key.split('.');

                            //ถ้า error ใน criterias
                            if(splited_key[0]=='criterias')
                            {                                
                                let evalStr = 'me.delivery_time_criterias'+me.travelAndSetNode(me.delivery_time_criterias,0,splited_key,errorMessage[key][0])

                                let evalStrForErrorStatus = evalStr+'.error = true';
                                let evalStrForErrorMessage = evalStr+'.message = "'+errorMessage[key][0]+'"';

                                eval(evalStrForErrorStatus);
                                eval(evalStrForErrorMessage);

                                me.delivery_time_criteria_item_data_entry_error = true;
                            }
                        })

                    }else{
                        console.log(errors.response.data._infos.result);
                        alert('ไม่สามารถบันทึกได้ ติดต่อเจ้าหน้าที่'+ errors.response.data);
                    }                    
                });
                   
            },            
            travelAndSetNode(obj,keyIdx,splited_key,errorMessage){
                //ท่องไปตาม node ต่างๆของเมนู item เพื่อไป show error message

                // console.log(obj); console.log(splited_key, splited_key[keyIdx], keyIdx);
                const leafNodes = ['key','value','message','start_active','end_active','enabled'];
                if(leafNodes.includes(splited_key[keyIdx])){    
                    // console.log('oh Yes')
                    return splited_key[keyIdx];
                }else{
                    // console.log('oh No')
                    keyIdx++;    
                    if(splited_key[keyIdx]=='children'){                        
                        // console.log('oh No 1')
                        return 'children'+this.travelAndSetNode(obj['children'],keyIdx,splited_key,errorMessage);
                    }else{                  
                        // console.log('oh No 2'); // console.log(splited_key[keyIdx]);       
                        if(leafNodes.includes(splited_key[keyIdx])){
                            return 'validateError.'+this.travelAndSetNode(obj[parseInt(splited_key[keyIdx])],keyIdx,splited_key,errorMessage);
                        }else{
                            return '['+splited_key[keyIdx]+'].'+this.travelAndSetNode(obj[parseInt(splited_key[keyIdx])],keyIdx,splited_key,errorMessage);
                        }                                                
                    }
                }
            },
            fetchLanguages(url){
                url = url || '/fetch/language';
                axios.get(url).then(response => {
                    this.languages = response.data.items;    
                })
                .catch(errors => {
                    console.log(errors);
                })
                ;
            },
            fetchdelivery_time_criteria_keys(url){
                url = url || this.base_url+'/key';
                axios.get(url).then(response => {
                    this.delivery_time_criteria_keys = response.data.delivery_criteria_keys;
                    this.fetch();
                })
                .catch(errors => {
                    console.log(errors);
                })
                ;
            },
            fetchOpenHour(){
                axios.get(this.base_url+'/fetch-open-hour').then(response => {
                    // console.log(response.data);
                    //เอาข้อมูลแต่ละฟิลด์ใส่ฟอร์มหลังจากโหลดมาแล้ว
                    this.open_hours = response.data.open_hours;
                })
                .catch(errors => {
                    // console.log(errors);
                    // alert('ไม่สามารถดึง record id='+id+' ได้');
                })
                ;
            },
            addNewOpenHour(){
                let new_open_hour = {
                    id:Object.entries(this.open_hours).length,
                    day_of_week:'',start:'',end:'',start_active:'',end_active:'',priority:'',enabled:'',
                }
                this.open_hours.push(new_open_hour);  
            },
            deleteOpenHour(delete_open_hour){
                let new_open_hours = [];
                Object.entries(this.open_hours).forEach(function(open_hour){
                    // console.log(delete_open_hour);
                    // console.log(open_hour);
                    if(delete_open_hour.id != open_hour[1].id){
                        new_open_hours.push(open_hour[1]);
                    }
                });
                // console.log(new_open_hours);
                this.open_hours = new_open_hours;
            },
            saveOpenHour(){
                this.showLoading=true;
                this.open_hour_data_saved_show = false;
                axios
                .post(this.base_url+'/save-open-hour',{'open-hours':this.open_hours})
                .then(response => {
                    this.showLoading=false;
                    console.log(response);
                    this.open_hour_data_entry_error = false;     
                    this.open_hour_data_entry_error_message = '';
                    this.open_hour_data_saved_show = true;
                }).catch(errors => {
                    this.showLoading=false;
                    this.open_hour_data_saved_show = false;
                    if(errors.response.data.message){
                        let errorMessage = errors.response.data.message;   
                        this.open_hour_data_entry_error = true;                        
                        let me = this;
                        Object.entries(errorMessage).forEach(function(item){
                            console.log(item[1][0]);
                            me.open_hour_data_entry_error_message = item[1][0];
                            return;
                        });
                        // this.open_hour_data_entry_error_message = errorMessage[item][0];
                        
                    }else{
                        console.log(errors.response.data._infos.result);
                        alert('ไม่สามารถบันทึกได้ ติดต่อเจ้าหน้าที่'+ errors.response.data);
                    }                    
                });
            },
            testCriterias(){
                this.showLoading=true;
                this.criteriaTestResult.show = false;
                console.log(this.testCriteria);
                axios
                .post(this.base_url+'/test-criterias',{'delivery':{delivery_date:this.testCriteria.date,delivery_time:this.testCriteria.time}})
                .then(response => {                    
                    this.showLoading=false;
                    
                    // this.criteriaTestResult = response.data;
                    this.criteriaTestResult.valid = response.data.valid;
                    this.criteriaTestResult.error_message = response.data.error_message[0];
                    this.criteriaTestResult.show = true;
                    console.log(this.criteriaTestResult);

                }).catch(errors => {       
                    this.showLoading=false;             
                    if(errors.response.data.message){                        
                    }else{
                        console.log(errors.response.data._infos.result);
                        alert('ไม่สามารถทดสอบได้ ติดต่อเจ้าหน้าที่'+ errors.response.data);
                    }                    
                });
            },
        },
    }
</script>

